import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './SubscriptionPause.module.css';
import HeroSection from '../../components/Verification/HeroSection/HeroSection';
import PauseOption from './components/PauseOption';
import GlobalModal from '../../components/UI/Popups/GlobalModal/GlobalModal';
import ImageSection from './components/ImageSection';
import { Typography } from '../../components/Typography/typography';
import { CancelSection } from '../DiscountOffer/components';
import { fetchUserByToken } from '../../app/features/userSlice';
import { activeFreePlan, cancelSubscription, pauseSubscription } from '../../services/paymentService';

import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

const SubscriptionPause = () => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [selectedWeeks, setSelectedWeeks] = useState(null);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const userToken = useSelector(state => state.user.token);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handlePause = (weeks) => {
        setLoading(true);

        pauseSubscription(userToken, weeks)
            .then(response => {
                toast.success(t('subscription.pause.success', { weeks, date: new Date(response.resumeDate).toLocaleDateString() }));

                // Refresh user data
                dispatch(fetchUserByToken(userToken));
                setLoading(false);

                // Navigate to billing page
                navigate('/profile/billing');
            })
            .catch(error => {
                console.error('Error pausing subscription:', error);
                toast.error(t('subscription.pause.error'));
                setLoading(false);
            });
    };

    const handleProceedToCancel = () => {
        setLoading(true);
        activeFreePlan({ token: userToken })
            .then((res) => {
                toast.success(t('subscription.cancel_success'));
                dispatch(fetchUserByToken(userToken));
                navigate('/profile/billing');
                setLoading(false);
            })
        // cancelSubscription({ token: userToken, endOfPeriod: true })
        //     .then((res) => {
        //         toast.success(t('subscription.cancel_success'));
        //         dispatch(fetchUserByToken(userToken));
        //          navigate('/profile/billing');
        //         setLoading(false);
        //    })
        //     .catch(error => {
        //         // console.error(error);
        //         setLoading(false);
        //     });
    };

    const handlePauseSelection = (weeks) => {
        setSelectedWeeks(weeks);
        setShowConfirmationModal(true);
    };

    const isPauseOptionSelected = (weeks) => {
        return selectedWeeks === weeks;
    };

    return (
        <div className={styles.container}>
            <HeroSection
                title={t('subscription.pause.hero.title')}
                desc={t('subscription.pause.hero.description')}
                withOutVerification={true}
            />

            <div className={styles.content}>
                <ImageSection />
                <div style={{ display: "flex", width: "auto" }}></div>
                <div className={styles.pauseSection}>
                    <div className={styles.pauseTitle}>
                        <Typography
                            title={t('subscription.pause.select_duration')}
                            fontSize={34}
                            weight="600"
                            color="#333"
                        />
                    </div>
                    <div className={styles.pauseOptions}>
                        <PauseOption
                            weeks={3}
                            onPause={() => handlePauseSelection(3)}
                            isSelected={isPauseOptionSelected(3)}
                        />
                        <PauseOption
                            weeks={4}
                            onPause={() => handlePauseSelection(4)}
                            isSelected={isPauseOptionSelected(4)}
                        />
                        <PauseOption
                            weeks={6}
                            onPause={() => handlePauseSelection(6)}
                            isSelected={isPauseOptionSelected(6)}
                        />
                    </div>
                </div>
            </div>

            <CancelSection
                onProceedToCancel={handleProceedToCancel}
                loading={loading}
            />

            <GlobalModal
                show={showConfirmationModal}
                onClose={() => setShowConfirmationModal(false)}
                title={t('subscription.pause.confirmation.title', 'Confirm Subscription Pause')}
                message={t('subscription.pause.confirmation.message', { weeks: selectedWeeks }, 'Are you sure you want to pause your subscription for {{weeks}} weeks?')}
                primaryButtonText={t('subscription.pause.confirmation.confirm', 'Yes, Pause Subscription')}
                secondaryButtonText={t('general.UI.cancel', 'Cancel')}
                primaryButtonAction={() => {
                    setShowConfirmationModal(false);
                    handlePause(selectedWeeks);
                }}
                secondaryButtonAction={() => setShowConfirmationModal(false)}
            />
        </div>
    );
};

export default SubscriptionPause; 